import TestIndex from "./components/Index"

let module = "test"

export default [{ path: "test", component: TestIndex, meta: { module: module, permissions: ["all"] } }]
